import {
  Box,
  Button,
  Card,
  CheckIcon,
  ChevronRightIcon,
  Flex,
  PartnerLogo,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import styles from './brandSpecialCallout.module.css';

export interface BrandSpecialCalloutProps {
  brandImage: string | null;
  brandName: string;
  isApplied: boolean;
  isAuthenticated: boolean;
  isQualified: boolean;
  onClick?: () => void;
  segmented?: boolean;
  specialTitle: string;
  specialType: 'product' | 'bundle';
  variant: 'pdp' | 'bag' | 'checkout';
}

export const BrandSpecialCallout = ({
  brandImage,
  brandName,
  isApplied,
  isAuthenticated,
  isQualified,
  onClick,
  segmented = false,
  specialTitle,
  specialType,
  variant,
}: BrandSpecialCalloutProps) => {
  const isMobile = useMobileMediaQuery({});
  const isBundle = specialType === 'bundle';
  const isProduct = specialType === 'product';
  const isUnlocked = isApplied || isQualified;
  const isBag = variant === 'bag';
  const isCheckout = variant === 'checkout';
  const isPdp = variant === 'pdp';

  const showButton = onClick && isBundle && !isUnlocked && !isMobile;
  const showIconButton = onClick && isBundle && !isUnlocked && isMobile;
  const showSignIn = segmented && !isAuthenticated;
  const showCheck = isApplied && (isAuthenticated || !segmented);
  const showBrandName = isBag && brandName;

  if ((isCheckout || isBag) && (isUnlocked || isProduct)) return null;

  return (
    <Card
      flat
      border="transparent-black-ten"
      className={styles['border__radius__lg']}
      width="100%"
      {...((showButton || showIconButton || isPdp) && {
        onClick,
        ariaLabel: 'view special',
      })}
    >
      <Card.Content>
        <Flex gap={16} alignItems="center">
          <PartnerLogo
            name={brandName}
            image={brandImage}
            variant="brand"
            size="xs"
            data-testid="partner-logo"
          />

          <Box overflow="hidden">
            {(isBag || showSignIn) && (
              <Typography color="text-light">
                {showBrandName && brandName}
                {showBrandName && showSignIn && (
                  <Typography mx={4} as="span" color="grays-mid">
                    &#8226;
                  </Typography>
                )}
                {showSignIn && 'Sign in for eligibility'}
              </Typography>
            )}

            <Typography
              variant="body-semibold"
              maxLines={showBrandName || showSignIn ? 1 : 2}
            >
              {specialTitle}
            </Typography>
          </Box>

          <Flex grow>
            {showButton && (
              <Button
                ml="auto"
                label={`View${isPdp ? ' bundle' : ''}`}
                variant="tertiary"
              />
            )}

            {showIconButton && (
              <Button.Icon
                ml="auto"
                variant="tertiary"
                icon={<ChevronRightIcon size="sm" />}
              />
            )}

            {showCheck && <CheckIcon ml="auto" />}
          </Flex>
        </Flex>
      </Card.Content>
    </Card>
  );
};
